import script from "./inspiration_image.vue?vue&type=script&setup=true&lang=js"
export * from "./inspiration_image.vue?vue&type=script&setup=true&lang=js"

import "./inspiration_image.vue?vue&type=style&index=0&id=a63f73f8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a63f73f8"]])

export default __exports__